export enum ArticleSearchStatus {
	published = 'published',
	unpublished = 'unpublished',
}
